import UserStoryList from "./pages/ListPage.vue";
import UserStoryDetail from "./pages/FormPage.vue";
import UserStoryIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/user_story",
    component: UserStoryIndex,
    redirect: "/user_story/list",
    name: "user_story",
    children: [
      {
        path: "list",
        component: UserStoryList,
        name: "user_story.list",
      },
      {
        path: "create",
        component: UserStoryDetail,
        name: "user_story.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: UserStoryDetail,
        name: "user_story.edit",
        props: { create: false },
      },
    ],
  },
];
